import React from 'react'
import PropTypes from 'prop-types'

export default function Curtain(props) {
  return <button className="dashboard-curtain" onClick={props.toggleDashboard} />
}

Curtain.propTypes = {
  toggleDashboard: PropTypes.func,
}
